// extracted by mini-css-extract-plugin
export default {"Info":"info_Info__TC3ec","Info__img":"info_Info__img__j6A21","Info__text":"info_Info__text__j4zLI"};